export default __webpack_public_path__ + "static/media/art-blk-poster-1.b02ddc58.jpg";